import React from 'react';

import dec from '../../../images/green_decoration.svg';

import { FOHImage } from '../../ingredients';

export const FOHGreenDecoration = () => (
  <FOHImage source={{ uri: dec }} style={{ width: 40, height: 20 }} />
);
